<script>
  import { createEventDispatcher } from 'svelte';
  import { getFirestore, doc, setDoc } from "firebase/firestore";
  const db = getFirestore();
  
  export let appPageTitle;
  export let dbUser;
  export let toggleEditChat;
  export let currChatRecord;
  
  const dispatch = createEventDispatcher();
  
  //console.log("EditChat");
  //console.log(currChatRecord);

  let name = currChatRecord?.userName || dbUser.name;
  let bio = currChatRecord?.userBio || dbUser.bio;
  let successMessage = "";
  
  const updateChat = async () => {
    //console.log("updateChat: " + dbUser.uid + ", "+currChatRecord.title);
    if(!name) {
      name = "";
    }
    if(!bio) {
      bio = "";
    }

    // Update the chat record instead of the user record
    const chatDocRef = doc(db, 'chats', dbUser.uid, 'userChats', currChatRecord.id);
    await setDoc(chatDocRef, { userName: name, userBio: bio }, { merge: true });
    
    
    currChatRecord = { ...currChatRecord, userName: name, userBio: bio };

    //console.log("update done: "+currChatRecord.title);

    // Notify the parent component of the update
    dispatch('update', currChatRecord );

    successMessage = "Options have been updated.";
  };

   let selectedSpeed = "Normal";
   if(currChatRecord.narrativeSpeed) {
      selectedSpeed = currChatRecord.narrativeSpeed;
   }

  async function changeNarrativeSpeed(speed) {
    selectedSpeed = speed;
    //console.log("Selected Speed:", selectedSpeed);
    
    // Update the chat record instead of the user record
    const chatDocRef = doc(db, 'chats', dbUser.uid, 'userChats', currChatRecord.id);
    await setDoc(chatDocRef, { narrativeSpeed: selectedSpeed }, { merge: true });
    
    currChatRecord = { ...currChatRecord, narrativeSpeed: selectedSpeed };

   // console.log("narrative speed change: "+selectedSpeed);

    // Notify the parent component of the update
    dispatch('update', currChatRecord );

    successMessage = "Narrative pace has been updated to "+selectedSpeed+".";
    // You can also update Firebase or do other operations here
  }

  // deleteChat(chat.id)
</script>

<div class="fixed inset-0 w-screen h-screen flex items-center justify-center z-50">
  <!-- Background overlay -->
  <div class="absolute inset-0 bg-black opacity-70" on:click={toggleEditChat}></div>

  <!-- Modal content -->
  <div class="relative w-[600px] h-[95vh] max-h-[95vh] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-auto overflow-x-hidden">

  <div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
    
    <div>

      <div class="flex items-center gap-x-4">
        
       
        <h3 id="tier-starter" class="text-lg font-semibold leading-8">{currChatRecord.title} Options</h3>



        <div class="ml-auto">
            <p 
                class="rounded-full text-base font-semibold leading-5 text-gray-400 hover:text-white cursor-default"
                on:click={toggleEditChat}
            >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </p>
        </div>
    </div>

    <div class="p-4 mt-4 rounded-lg shadow-md space-y-4">
      {#if successMessage}
        <div class="rounded-lg px-3 py-3 mb-2 -ml-2 bg-slate-100 dark:bg-slate-750 flex justify-between items-center">
          <p class="text-white-500 mb-3">{successMessage}</p>
          <button on:click={toggleEditChat} class="bg-blue-500 text-white px-4 py-2">
            Close
          </button>
        </div>


      {/if}

      <div>
        <label>Narrative Pace:</label>
        <br>
        <div class="w-full flex justify-center p-2">
        <button 
          class="flex-1 px-4 py-2 border border-r-0 rounded-l-lg focus:outline-none transition duration-300"
          class:bg-blue-500={selectedSpeed === "Slow"}
          on:click={() => changeNarrativeSpeed("Slow")}>Slow</button>
          
        <button 
          class="flex-1 px-4 py-2 border border-r-0 focus:outline-none transition duration-300"
          class:bg-blue-500={selectedSpeed === "Normal"}
          on:click={() => changeNarrativeSpeed("Normal")}>Normal</button>
          
        <button 
          class="flex-1 px-4 py-2 border rounded-r-lg focus:outline-none transition duration-300"
          class:bg-blue-500={selectedSpeed === "Fast"}
          on:click={() => changeNarrativeSpeed("Fast")}>Fast</button>
      </div>

      <style>
        button.bg-blue-500 {
          background-color: #3B82F6;
          color: white;
        }
      </style>
    </div>

    <hr class="border-slate-700">

      <div>
        <div class="mb-1">
          <label for="name">{currChatRecord.title} knows you as:</label>
        </div>
        <input type="text" class="px-2 border text-black" bind:value={name} id="name">
      </div>
      <div>
        <div class="mb-1">
          <label for="bio">Your bio for {currChatRecord.title}:</label>
        </div>
        <textarea 
          class="w-full h-20 p-2 border text-black" 
          bind:value={bio} 
          id="bio"></textarea>
      </div>
      <div class="pb-2">
        <button class="bg-blue-500 text-white px-4 py-2" on:click={updateChat}>Update</button>
      </div>

      <hr class="border-slate-700">

      <div class="py-2 rounded-lg shadow-md">
          <button class="bg-red-900 text-white px-4 py-2 mt-4" on:click={() => dispatch('delete', currChatRecord.id)}>
         Delete Persona
        </button>
      </div>
  </div>

     </div>


  </div>
</div>

